<template>
  <div class="forms">
    <el-row>
      <el-col :span="14" :offset="5">
        <el-form
          :model="form"
          ref="items"
          label-width="180px"
          :hide-required-asterisk="true"
        >
          <el-form-item
            label="店舗"
            prop="clientGroup.name"
            :rules="[{ required: true, message: '店舗を選択してください。' }]"
          >
            <el-select
              @change="changeClientGroup($event)"
              :value="clientGroup.name"
            >
              <el-option :value="{}" label="未選択"></el-option>
              <el-option
                v-for="clientGroup in clientGroups"
                :key="clientGroup.id"
                :label="clientGroup.name"
                :value="clientGroup"
              >
                {{ clientGroup.name }}
              </el-option>
            </el-select>
            <span class="require-message">※必須</span>
            <p
              v-if="isEditMode"
              class="caption"
            >
              店舗を再選択した場合、自由項目の入力が初期化されるのでご注意ください
            </p>
          </el-form-item>
          <el-form-item label="支店" prop="deliveryDestination">
            <el-select
              @change="changeDeliveryDestination($event)"
              :value="deliveryDestination.name"
            >
              <el-option :value="{}" label="未選択"></el-option>
              <el-option
                v-for="deliveryDestination in deliveryDestinations"
                :key="deliveryDestination.id"
                :label="deliveryDestination.name"
                :value="deliveryDestination"
              >
                {{ deliveryDestination.name }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item
            label="お名前"
            prop="name"
            :rules="[{ required: true, message: '名前が必要です。' }]"
          >
            <el-input v-model="form.name" class="e-input"></el-input>
            <span class="require-message">※必須</span>
          </el-form-item>
          <div class="ZipcodeInput">
            <el-form-item
              label="郵便番号"
              prop="zipcode"
              :rules="[
                {
                  pattern: /^[0-9\-]+$/,
                  message: '半角英数で入力してください。'
                }
              ]"
              style="margin-bottom: 4px !important;"
              class="NonMargin"
            >
              <el-input
                @blur="toZipcodeFormat()"
                @focus="offZipcodeFormat()"
                maxlength="8"
                v-model="form.zipcode"
                class="e-input"
                id="zipcode"
                style="margin-bottom: 4px !important;"
              ></el-input>
            </el-form-item>
            <el-button
              class="SearchButton"
              @click="onClickGetAddress"
              type="primary"
              style="margin-bottom: 4px !important;"
              >住所を自動入力</el-button
            >
          </div>
          <el-form-item label="住所" prop="address">
            <el-input
              class="e-input"
              v-model="form.address"
              id="address"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="電話番号"
            prop="tel"
            :rules="[
              {
                pattern: /^[0-9\-]+$/,
                message: '半角英数、-（半角ハイフン）で入力してください。'
              }
            ]"
          >
            <el-input v-model="form.tel" class="e-input"></el-input>
          </el-form-item>
          <el-form-item label="宗派" prop="sect">
            <el-select @change="changeSect($event)" :value="sect">
              <div v-for="(sectList, index) in SECT_LIST" v-bind:key="index">
                <el-option :value="sectList">{{ sectList }}</el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="" v-if="sect === 'その他'">
            <el-input v-model="form.sect" class="e-input"></el-input>
          </el-form-item>
          <el-form-item label="菩提寺" prop="familyTemple">
            <el-input v-model="form.familyTemple" class="e-input"></el-input>
          </el-form-item>
          <el-form-item
            label="四十九日法要日"
            prop="fortyNinthMemorialServiceDate"
          >
            <el-date-picker
              id="date-input"
              class="FormGroup-Form FormGroup-Margin"
              v-model="orderDetail.fortyNinthMemorialServiceDate"
              type="date"
              @focus="onBlur()"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="ご契約日" prop="contractDate">
            <el-date-picker
              id="date-input"
              class="FormGroup-Form FormGroup-Margin"
              v-model="orderDetail.contractDate"
              type="date"
              @focus="onBlur()"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="納品日" prop="deliveryDate">
            <el-date-picker
              id="date-input"
              class="FormGroup-Form FormGroup-Margin"
              v-model="orderDetail.deliveryDate"
              type="date"
              @focus="onBlur()"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="顧客番号" prop="customerNumber">
            <el-input
              v-model="form.customerNumber"
              class="e-input"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="備考" prop="note">
            <el-input
              :autosize="{ minRows: 2, maxRows: 100 }"
              type="textarea"
              v-model="form.note"
              class="e-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="ファイル">
            <el-upload
              class="AddAttachmentButton"
              ref="upload"
              action
              :auto-upload="false"
              :on-change="_onChangeAttachment"
              :file-list="fileList"
              accept=".jpg, .jpeg, .png, .doc, .xls, .ppt, .docx, .xlsx, .pptx, .pdf, .txt, .bmp"
              :on-remove="_onRemoveAttachment"
            >
              <el-button size="small" type="default">ファイルを選択 </el-button>
            </el-upload>
          </el-form-item>
        </el-form>

        <!-- customFields -->
        <template v-for="item in customFields">
          <el-form
            label-width="180px"
            :model="item"
            :ref="`customField${item.customFieldNumber}`"
            :key="`customField${item.customFieldNumber}`"
            :hide-required-asterisk="true"
          >
            <el-form-item
              prop="value"
              :label="item.name"
              :rules="fetchCustomFieldRules(item)"
            >
              <!-- テキスト型 -->
              <el-input
                v-if="item.type === 'TEXT'"
                v-model="item.value"
                class="e-input"
                style="margin-bottom: 4px !important;"
              />

              <!-- テキストリスト型 -->
              <el-select
                v-if="item.type === 'TEXT_LIST'"
                v-model="item.value"
                @change="onChangeCustomField"
              >
                <el-option
                  v-for="(listItem, number) in fetchListItems(item)"
                  :key="`customField${item.customFieldNumber}-list${number}`"
                  :label="listItem"
                  :value="listItem"
                >
                  {{ listItem }}
                </el-option>
              </el-select>

              <!-- 整数型 -->
              <el-input
                v-if="item.type === 'INT'"
                v-model="item.value"
                class="e-input"
              />

              <!-- 実数型 -->
              <el-input
                v-if="item.type === 'FLOAT'"
                v-model="item.value"
                class="e-input"
              />

              <!-- 日付形 -->
              <el-date-picker
                v-if="item.type === 'DATE'"
                v-model="item.value"
                type="date"
                :editable="false"
                :clearable="fetchIsRequiredCustomFieldInput(item)"
                @change="onChangeCustomField"
              />

              <!-- 必須項目かどうか -->
              <span
                v-if="fetchIsRequiredCustomFieldInput(item)"
                class="require-message"
              >
                ※必須
              </span>
            </el-form-item>
          </el-form>
        </template>
      </el-col>
    </el-row>

    <!-- footer -->
    <div>
      <OrderFormFooter
        style="color:#2c3e50"
        message="お客様情報をご入力ください"
        :canClickGoForward="true"
        @onClickGoForward="onClickNext"
      />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueJsonp from "vue-jsonp";
import { mapGetters } from "vuex";

import SECT_LIST from "../const/sectList.js";

import OrderFormFooter from "@/components/OrderFormFooter";

import UserUsecase from "@/usecases/user.usecase";
import FileUsecase from "@/usecases/file.usecase";
import OrderUsecase from "@/usecases/order.usecase";

// import SanskritCharacterService from "@/services/sanskritCharacter.service";
import { apiErrorHandler } from "@/services/apiErrorHandler";

const ZIPCODE_API_URL = "https://zipcloud.ibsnet.co.jp/api/search";

Vue.use(VueJsonp);

export default {
  data () {
    return {
      zipcode: "",
      address: "",
      message: "",
      sect: "",
      fileList: [],
      sects: [],
      clientGroups: [],
      deliveryDestinations: [],
      loadingView: {},
    };
  },
  components: {
    OrderFormFooter,
  },
  created () {
    this.getSects();
  },
  async mounted () {
    this.$store.commit("orderForm/setCurrentStep", 0);
    try {
      const user = await usecase.user.getMe({
        userId: this.$store.state.user.sub,
      });
      this.clientGroups = user.clientGroups;
      this.deliveryDestinations = this.clientGroup.deliveryDestinations || [];
    } catch (err) {
      apiErrorHandler(this, err);
    } finally {
      this.isLoadingDialog = false;
    }
  },
  computed: {
    SECT_LIST () {
      return SECT_LIST.sects;
    },
    form: {
      get () {
        return this.$store.state.orderForm.customerInput;
      },
      async set (value) {
        this.$store.commit("orderForm/setCustomerInput", { ...value });
      },
    },
    orderDetail: {
      get () {
        return this.$store.state.orderForm.detailInput;
      },
      async set (value) {
        this.$store.commit("orderForm/setDetail", { ...value });
      },
    },
    clientGroup: {
      get () {
        return this.$store.state.orderForm.clientGroupInput;
      },
      async set (value) {
        this.$store.commit("orderForm/setClientGroupInput", value);
      },
    },
    deliveryDestination: {
      get () {
        return this.$store.state.orderForm.deliveryDestinationInput;
      },
      async set (value) {
        this.$store.commit("orderForm/setDeliveryDestinationInput", value);
      },
    },
    customFields: {
      get () {
        return this.$store.state.orderForm.customFields;
      },
      async set (value) {
        this.$store.commit("orderForm/setCustomFields", value);
      },
    },
    itemSettings: {
      get () {
        return this.$store.state.orderForm.itemSettings;
      },
      async set (value) {
        this.$store.commit("orderForm/setItemSettings", value);
      },
    },
    ...mapGetters({
      nextStep: "orderForm/nextStep",
      isEditMode: "orderForm/isEditMode",
    }),
  },
  methods: {
    onSetOrderForm () {
      this.initFileList();
    },
    async getSects () {
      try {
        const count = SECT_LIST.sects.length;
        let orderedInfo = this.$store.state.orderForm.customerInput;
        if (orderedInfo.sect) {
          for (let i = 0; i < count; i++) {
            // eslint-disable-next-line
            SECT_LIST.sects[i];
            if (orderedInfo.sect === "その他") {
              this.sectIsEtc = true;
              break;
            } else if (SECT_LIST.sects[i] === orderedInfo.sect) {
              this.sectIsEtc = false;
              this.sect = orderedInfo.sect;
              break;
            } else {
              this.sectIsEtc = true;
              this.sect = "その他";
            }
          }
        }
      } catch (err) {
        apiErrorHandler(this, err);
      }
    },
    initFileList () {
      this.fileList = this.orderDetail.attachments.map(filePath => {
        const originalFileName = filePath
          .split("/")
          .pop()
          .slice(14);
        return {
          uid: filePath,
          name: originalFileName,
          status: "ready",
          key: filePath,
        };
      });
    },

    /**
     * [_onChangeAttachment description]
     * @param   {[type]}  file      [file description]
     * @param   {[type]}  fileList  [fileList description]
     * @return  {[type]}            [return description]
     */
    async _onChangeAttachment (file, fileList) {
      const { raw, name } = file;

      // アップロード時のファイルサイズ制限
      // xxlarge: 15MB まで
      if (!usecase.file.validateFileSize(file, "xxlarge")) {
        // Clear file list
        // this.$refs.upload.clearFiles();

        // Pop file list
        fileList.pop();

        return;
      }

      // 保存する画像のカテゴリを分ける
      const category = "plainwood";

      // ２バイト文字のファイル名をエスケープするかどうか（エンコード）
      const isEncode = true;

      try {
        const fileName = usecase.file.fetchFileName(name, category, isEncode);

        const result = await usecase.file.uploadFile(fileName, raw);

        file.key = result.key;
        this.orderDetail.attachments.push(result.key);

        this.fileList = fileList;
      } catch (err) {
        console.log(err);

        // Pop file list
        fileList.pop();
      }
    },
    async _onRemoveAttachment (file) {
      this.orderDetail.attachments = this.orderDetail.attachments.filter(
        attachment => {
          if (attachment === file.key) {
            return false;
          } else {
            return true;
          }
        }
      );
    },
    viewImage (item) {
      this.dialogVisible = true;
      this.imgDetail = item;
    },
    changeSect (event) {
      this.sect = event;
      this.form.sect = event;
      if (event === "その他") {
        this.form = { ...this.form, sect: "" };
      }
    },
    changeClientGroup (event) {
      this.clientGroup = event;
      this.form.clientGroup = event;
      this.deliveryDestination = {};
      this.form.deliveryDestination = {};
      this.deliveryDestinations = event.deliveryDestinations || [];

      // customFields
      this.fetchCustomFields();
    },
    changeDeliveryDestination (event) {
      this.deliveryDestination = event;
      this.form.deliveryDestination = event;
    },
    toZipcodeFormat () {
      var zipcode = document.getElementById("zipcode").value;
      if (zipcode.trim().length === 7 && !isNaN(zipcode)) {
        var str = zipcode.trim();
        var h = str.substr(0, 3);
        var m = str.substr(3);
        zipcode = h + "-" + m;
        this.form.zipcode = zipcode;
      }
    },
    offZipcodeFormat () {
      var zipcode = document.getElementById("zipcode").value;
      var reg = new RegExp("-", "g");
      var chgVal = zipcode.replace(reg, "");
      if (!isNaN(chgVal)) {
        zipcode = chgVal; // 値セット
        this.form.zipcode = zipcode;
      }
    },
    onBlur () {
      document.activeElement.blur();
      document.getElementById("date-input").blur();
    },
    async onClickGetAddress () {
      try {
        var zipcode = document.getElementById("zipcode").value;
        const result = await this.$jsonp(
          ZIPCODE_API_URL + "?zipcode=" + zipcode
        );

        // 返却されたデータを挿入する
        this.form.address =
          result.results[0].address1 +
          result.results[0].address2 +
          result.results[0].address3;
      } catch (err) {
        this.loading = false;
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "住所が見つかりませんでした。",
        });
        this.form.address = "";
      }
    },
    onClickNext () {
      const { itemSettings } = this;
      const isValid = {
        items: false,
        customFields: true,
      };

      if (this.form.sect === "") {
        this.form.sect = "その他";
      }

      this.$refs.items.validate(valid => {
        if (valid) {
          isValid.items = true;
        }
      });

      console.log(this.$refs["items"], "items");

      itemSettings.forEach(itemSetting => {
        const ref = `customField${itemSetting.customFieldNumber}`;

        this.$refs[ref][0].validate(valid => {
          if (!valid) {
            isValid.customFields = false;
          }
        });
      });

      if (
        isValid.items &&
        isValid.customFields
      ) {
        const { $router } = this;
        this.$store.commit("orderForm/setCustomerInput", this.form);
        $router.push(this.nextStep);
      }
    },
    goToDraft () {
      this.draftDialog = true;
    },
    // continueOrder () {
    //   this.continue = true;
    // },
    goToHome () {
      this.$router.push("/home");
    },
    inputParam () {
      this.$store.commit("orderForm/setCustomerInput", this.items);
    },

    /**
     * [fetchCustomFields description]
     */
    async fetchCustomFields () {
      const clientGroupId = this.form.clientGroup.id;

      // 初期化
      this.$store.commit("orderForm/setItemSettings", []);
      this.$store.commit("orderForm/setCustomFields", []);

      if (!clientGroupId) {
        return;
      }

      this.loadingView = this.$loading();

      try {
        const res = await this.fetchOrderCustomFieldConfig();

        this.setCustomFields(res);
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.loadingView.close();
      }
    },

    /**
     * [fetchOrderCustomFieldConfig description]
     * @return  {[type]}  [return description]
     */
    async fetchOrderCustomFieldConfig () {
      const options = this.fetchOrderCustomFieldOptions();
      const res = await usecase.order.getOrderCustomFieldConfig(options);

      return res;
    },

    /**
     * [fetchOrderCustomFieldOptions description]
     * @return  {[type]}  [return description]
     */
    fetchOrderCustomFieldOptions () {
      const clientGroupId = this.form.clientGroup.id;
      const options = { clientGroupId };

      return options;
    },

    /**
     * [setCustomFields description]
     * @param   {[type]}  res  [res description]
     */
    setCustomFields (res) {
      if (!res.data) {
        return;
      }

      const itemSettings = [];

      // 管理画面で登録された自由項目から enabled の項目のみ取得する
      res.data.orderCustomFieldConfig.itemSettings
        .sort((a, b) => {
          return a.order < b.order ? -1 : 1;
        })
        .forEach(itemSetting => {
          if (itemSetting.enabled) {
            itemSettings.push(itemSetting);
          }
        });

      // 得意先での自由項目の入力形式で形成
      const customFields = itemSettings.map((itemSetting) => {
        const {
          customFieldNumber,
          type,
          name,
          order,
          defaultValue,
        } = itemSetting;
        const value = defaultValue || null;
        const customField = {
          customFieldNumber,
          type,
          name,
          order,
          value,
        };

        return customField;
      });

      this.$store.commit("orderForm/setItemSettings", itemSettings);
      this.$store.commit("orderForm/setCustomFields", customFields);
    },

    /**
     * [fetchIsRequiredCustomFieldInput description]
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    fetchIsRequiredCustomFieldInput (item) {
      const { itemSettings } = this;
      const target = itemSettings.find(itemSetting => itemSetting.customFieldNumber === item.customFieldNumber);

      return target ? target.required : false;
    },

    /**
     * [fetchListItems description]
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    fetchListItems (item) {
      const { itemSettings } = this;
      const target = itemSettings.find(itemSetting => itemSetting.customFieldNumber === item.customFieldNumber);

      return target.listItems;
    },

    /**
     * [fetchCustomFieldRules description]
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    fetchCustomFieldRules (item) {
      const rules = [];
      const isRequired = this.fetchIsRequiredCustomFieldInput(item);

      // 必須項目かどうか
      if (isRequired) {
        rules.push({
          required: true,
          message: "必須項目です。",
        });
      }

      // 整数型かどうか
      if (item.type === "INT") {
        rules.push({
          pattern: /^[+,-]?([1-9]\d*|0)$/,
          message: "整数で入力してください。",
        });
      }

      // 実数型かどうか
      if (item.type === "FLOAT") {
        rules.push({
          pattern: /^[+,-]?([1-9]\d*|0)(\.\d+)?$/,
          message: "実数で入力してください。",
        });
      }

      return rules;
    },

    /**
     * [onChangeCustomField description]
     */
    onChangeCustomField () {
      this.$store.commit("orderForm/setCustomFields", this.customFields);
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
    usecase.order = new OrderUsecase();
    usecase.user = new UserUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
// const sanskritCharacterService = new SanskritCharacterService();
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.ZipcodeInput {
  display: grid;
  grid-template-columns: repeat(2, 3fr);
}
.NonBlock {
  display: grid;
  grid-template-columns: 300px 1fr;
}
.SearchButton {
  height: 40px;
  width: 120px;
  margin-left: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.forms .el-form-item {
  margin-bottom: 22px !important;
}
.forms .el-form-item__label {
  line-height: 40px !important;
  padding-left: 35px !important;
}
.forms .el-form-item__label {
  text-align: left !important;
  color: $text-base;
}
.forms
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: none !important;
}
.forms .el-form-item__error {
  top: 2.6rem !important;
}

/* .forms {
} */
.formContainer {
  margin-bottom: 25px;
}
.e-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 90%;
}
@media (max-width: 1024px) {
  .e-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 80%;
  }
}
.require-message {
  color: $red-base; // #f56c6c;
  float: right;
}

.caption {
  margin-bottom: 0;
  margin-block-start: 0.5rem;
  line-height: 1.3;
  font-size: 12px;
  color: $red-base;
}
</style>
